var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 106,
    viewBox: "0 0 160 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 66C20 49.4315 33.4315 36 50 36H110C126.569 36 140 49.4315 140 66C140 82.5685 126.569 96 110 96H50C33.4315 96 20 82.5685 20 66Z",
    fill: "#F3F3F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 44.5,
    r: 35,
    fill: "white",
    stroke: "#F3F3F5",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0417 44C63.0417 54.1255 71.2495 62.3333 81.375 62.3333C91.5005 62.3333 99.7084 54.1255 99.7084 44C99.7084 33.8745 91.5005 25.6667 81.375 25.6667M67.8982 31.3115C68.1512 31.0426 68.4121 30.7811 68.681 30.5268M73.9445 27.005C74.2782 26.8559 74.6161 26.7159 74.9584 26.5852M64.3837 36.5603C64.2321 36.8964 64.0904 37.2374 63.9584 37.5833M86.875 38.5L81.375 44M81.375 44L75.875 49.5M81.375 44L86.875 49.5M81.375 44L75.875 38.5",
    stroke: "#FF5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.2fd1048665307a6d7488d2677f33da71.svg";
export { ForwardRef as ReactComponent };